import React, { useState } from 'react';
import { Users } from 'lucide-react';

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' });
const tone = (n, size) => (n === 0 ? 'bg-emerald-50 border-emerald-200 text-emerald-700'
  : n / Math.max(size, 1) >= 0.3 ? 'bg-rose-50 border-rose-300 text-rose-700' : 'bg-amber-50 border-amber-200 text-amber-800');

// Manager preview: for each requested date, which teammates are already off (approved or pending).
export const TeamOverlapPreview = ({ overlap, leaveId }) => {
  const [open, setOpen] = useState(null);
  if (!overlap || !overlap.dates?.length) return null;
  const sel = overlap.dates.find((d) => d.date === open);
  return (
    <div className="mt-2 rounded-lg border border-slate-200 bg-slate-50/60 p-2" data-testid={`team-overlap-${leaveId}`}>
      <p className="text-[11px] font-medium text-slate-600 flex items-center gap-1 mb-1.5">
        <Users className="h-3 w-3" />Your team off (approved + pending) · {overlap.team_size} report to you
        {overlap.busiest === 0 && <span className="text-emerald-700 ml-1">— nobody else off</span>}
      </p>
      <div className="flex flex-wrap gap-1">
        {overlap.dates.map((d) => (
          <button key={d.date} type="button" onClick={() => setOpen(open === d.date ? null : d.date)}
            className={`text-[10px] px-1.5 py-0.5 rounded border transition-colors ${tone(d.off.length, overlap.team_size)} ${open === d.date ? 'ring-1 ring-slate-400' : ''}`}
            title={d.off.map((o) => o.name).join(', ') || 'Nobody off'} data-testid={`team-overlap-date-${leaveId}-${d.date}`}>
            {fmt(d.date)} · <b>{d.off.length}</b>
          </button>
        ))}
      </div>
      {sel && (
        <div className="mt-1.5 text-[11px] text-slate-700" data-testid={`team-overlap-list-${leaveId}`}>
          {sel.off.length ? sel.off.map((o) => (
            <p key={o.employee_id} className="flex items-center gap-1.5">
              <span className={`h-1.5 w-1.5 rounded-full ${o.status === 'approved' ? 'bg-emerald-500' : 'bg-amber-400'}`} />
              {o.name} <span className="text-slate-400">{(o.leave_type || '').replace('_', ' ')} · {o.status}</span>
            </p>
          )) : <p className="text-emerald-700">Nobody else is off on {fmt(sel.date)}.</p>}
        </div>
      )}
    </div>
  );
};
